import { vec3 } from 'gl-matrix'
import Node from 'nanogl-node'

export enum ScrollSide {
  LEFT = -1,
  ANY = 0,
  RIGHT = 1,
}

export type ScrollItem = {
  node: Node
  id: string
  lifetime: number
  side: ScrollSide
  position: vec3
  scale: number
  revealDuration: number
}

export default class BackgroundEntity {
  spawnableItems: string[] = []
  activeItems: ScrollItem[] = []

  minFrequency: number = 1
  maxFrequency: number = 3.5

  spawnTime: number = 0
  nextSpawn: number = 0.2
}
